module.exports = __webpack_public_path__ + "static/media/benefit_1.622b7e5d.jpg";